import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@atoms';
import type { InputProps } from '@atoms';

export interface SearchInputProps extends Omit<InputProps, 'className'> {
  /** Additional CSS classes for the container */
  className?: string;
  /** Additional CSS classes for the input */
  inputClassName?: string;
}

/**
 * SearchInput Molecule Component
 * 
 * An input field with a search icon, commonly used for filtering data.
 * 
 * @example
 * ```tsx
 * <SearchInput 
 *   placeholder="Search users..." 
 *   value={searchTerm}
 *   onChange={(e) => setSearchTerm(e.target.value)}
 * />
 * ```
 */
export const SearchInput: React.FC<SearchInputProps> = ({
  className = '',
  inputClassName = '',
  ...inputProps
}) => {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary w-4 h-4" />
      <Input
        {...inputProps}
        className={`pl-10 ${inputClassName}`}
      />
    </div>
  );
};
